
document.addEventListener('DOMContentLoaded',function(){
  var f=document.getElementById('create_customer');if(!f)return;
  function getLabelText(field){var l=f.querySelector('label[for="'+field.id+'"]');return l?l.textContent.trim():""}
  function isDisabledSelectValue(field){if(field.tagName!=='SELECT')return false;var opt=field.options[field.selectedIndex];return !opt||opt.disabled||opt.value===""}
  function splitTyped(noteEl){
    var typed=noteEl.value||'';var prev=noteEl.dataset.autoExtra||'';if(!prev)return typed.trim();
    var sep=' | ';var suf=typed.endsWith(sep+prev)?sep+prev:(typed.endsWith(prev)?prev:'');if(suf)typed=typed.slice(0,typed.length-suf.length);
    return typed.replace(/\s+\|?\s*$/,'').trim();
  }
  function compute(){
    var pairs=[];var tradeVal='';
    var fields=f.querySelectorAll('input[name^="custom_"],select[name^="custom_"],textarea[name^="custom_"]');
    fields.forEach(function(field){
      if(field.type==='password')return;
      var val=field.tagName==='SELECT'?(isDisabledSelectValue(field)?'':field.value||''):(field.type==='checkbox'?(field.checked?'Yes':''):field.value||'');
      if(!val)return;
      var label=getLabelText(field);
      pairs.push(label?label+': '+val:val);
      if(!tradeVal&&/trade/i.test(label))tradeVal=val;
    });
    var note=f.querySelector('textarea[name="customer[note]"]');if(!note){note=document.createElement('textarea');note.name='customer[note]';note.style.display='none';f.appendChild(note)}
    var typed=splitTyped(note);var extra=pairs.join(' | ');
    note.value=typed+(typed&&extra?' | ':'')+extra;
    note.dataset.autoExtra=extra;
    var tagInput=f.querySelector('input[name="customer[tags]"]');if(!tagInput){tagInput=document.createElement('input');tagInput.type='hidden';tagInput.name='customer[tags]';f.appendChild(tagInput)}
    var tags=['Trade Program'];if(tradeVal)tags.push(tradeVal);tagInput.value=tags.join(', ');
  }
  f.addEventListener('input',compute);
  f.addEventListener('change',compute);
  window.addEventListener('load',compute);
  window.addEventListener('pageshow',compute);
  var start=Date.now();var iv=setInterval(function(){compute();if(Date.now()-start>2000)clearInterval(iv)},150);
  f.addEventListener('submit',compute);
  compute();
});

(function(){
  var f=document.getElementById('create_customer');
  var wrap=f && f.closest('.se-wrap');
  if(!wrap) return;

  function qsHas(name){return new URLSearchParams(window.location.search).has(name);}

  if(qsHas('customer_posted')){
    var success=wrap.querySelector('.se-success');
    var errors=wrap.querySelector('.se-errors');
    if(success){ success.style.display='block'; }
    if(errors){ errors.style.display='none'; }
  }
})();

document.addEventListener('DOMContentLoaded', function() {
  var section = document.querySelector('.se-handpick-form');
  if (!section) return;

  var form = section.querySelector('form');
  if (!form) return;

  var query = new URLSearchParams(window.location.search);
  var success = query.get('registered') === '1' || query.get('customer_posted') === 'true';
  if (!success) return;

  var hasErrors = !!section.querySelector('.se-errors');
  if (hasErrors) return;

  var successBox = section.querySelector('.se-success');
  if (!successBox) {
    successBox = document.createElement('div');
    successBox.className = 'se-success';
    successBox.innerHTML = '<strong>Account created</strong><div>Please check your email for activation or next steps.</div>';
    successBox.style.display = 'none';
    form.parentNode.insertBefore(successBox, form);
  }

  successBox.style.display = 'block';
});
